export default "__VITE_ASSET__BMfbGoGP__"